import { isEmpty } from 'utils/browserHelper'
import Clevertap from 'analytics'

export const sendClevertapUIActionEvent = ({ actionName, actionType = 'BUTTON', page, ...additionalData }) => {
    let fullPayload = {
        action_name: actionName,
        action_type: actionType,
        source: 'web',
        domain: window.location.host,
        source_page_name: page,
        ...additionalData
        //dom_intl: ,
        //journey_type:
    }

    Clevertap.event('Air_UI_Action', fullPayload)
}
